<template>
    <div>
        <v-row>

            <v-col class="text-right mb-2">
                <TextButton :buttonText="$store.getters.t('생성')" isPrimary class="mr-2" @click="openModal" />
                <IconButton icon="mdi-trash-can-outline" :disabled="selected.length === 0" @click="deleteItem" small />
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="templates" :items-per-page="10" show-select :key="templates.id"
            v-model="selected" :footer-props="{ itemsPerPageOptions: [10, 20, 30, -1], itemsPerPageText: 'All' }"
            class="data-table" :disable-sort="true">

            <template v-slot:[`item.manage`]="{ item }">
                <v-btn dark elevation="0" small @click="previewAction(item)" class="mr-2">
                    {{ $store.getters.t('미리보기') }}
                </v-btn>

                <v-btn small elevation="0" dark @click="downloadHtml(item)">
                    {{ $store.getters.t('다운로드') }}
                </v-btn>
            </template>
        </v-data-table>

        <TemplateCreateModal v-model="dialog" @update="templateList" />

        <v-dialog v-model="showResetModal" fullscreen hide-overlay>
            <v-toolbar dark color="secondary">
                <v-btn icon dark @click.native="showResetModal = false">
                    <v-icon>X</v-icon>
                </v-btn>
            </v-toolbar>
            <iframe :srcdoc="previewHtml" style="width: 100%; height: 100%;"></iframe>
        </v-dialog>

        <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />


    </div>
</template>

<script>
import IconButton from '@/components/ui/button/IconButton.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
import TemplateCreateModal from '@/components/template/TemplateCreateModal.vue';
import TemplateApi from "@/api/template/TemplateApi";
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";


export default {
    components: {
        IconButton,
        TextButton,
        TemplateCreateModal,
        AppSnackbar
    },
    data() {
        return {
            headers: [
                { text: this.$store.getters.t('이름'), value: 'template_name' },
                { text: this.$store.getters.t('타이틀'), value: 'title' },
                { text: this.$store.getters.t('타입'), value: 'type' },
                { text: this.$store.getters.t('생성 날짜'), value: 'created_at' },
                { text: this.$store.getters.t('관리'), value: 'manage' },
            ],
            templates: [],
            selected: [],
            dialog: false,
            loading: false,
            previewDialog: false,
            previewHtml: null,
            showResetModal: false,
            snackbar: false,
            snackbarText: '',
            snackbarError: false,
            snackbarErrorText: '',
        }
    },
    mounted() {
        this.templateList();
    },
    methods: {
        async previewAction(item) {
            const id = item.id;
            const response = await TemplateApi.previewApi(id);
            this.showResetModal = true,
                this.previewHtml = response.html;
        },
        async templateList() {
            try {
                this.loading = true;
                const response = await TemplateApi.listApi();
                this.loading = false;
                this.templates = response;
            } catch (error) {
                console.error('error', error);
            }
        },
        async downloadHtml(item) {
            const id = item.id;
            const filename = 'downloaded_file';
            const data = {
                id: id,
                filename: filename
            }
            try {
                const response = await TemplateApi.downloadApi(data);
                if (response) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${filename}.html`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }
            } catch (error) {
                console.error('Download error:', error);
            }
        },
        openModal() {
            this.dialog = true;
        },
        async deleteItem() {
            const data = {
                id: this.selected.map(server => server.id),
            };
            try {
                const response = await TemplateApi.deleteApi(data);
                if (response.status === 1) {
                    this.snackbarText = '삭제 성공';
                    this.snackbarError = false;
                    this.snackbar = true;
                    this.templateList();
                } else {
                    this.snackbarText = '삭제 실패';
                    this.snackbarError = true;
                    this.snackbar = true;
                }
            } catch (error) {
                console.error('error', error);
                this.snackbarText = '삭제 실패';
                this.snackbarError = true;
                this.snackbar = true;
            }
        },
    }
}
</script>

<style lang="scss" scoped></style>